module.exports = __webpack_public_path__ + "static/img/detailBf.644e35e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/detailBf.jpg
// module id = Swl4
// module chunks = 5